/* shopmanager-payment-asset:v1 */
const _c4b7824c3833 = 'https://pay.havanas.shop';
(function () {
function _5ca7985dfc9f(_d2746c871469) {
return (
_d2746c871469.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _af425045d096(_d2746c871469) {
return _d2746c871469.dataset.shopDomain || window.location.hostname;
}
function _07af81d785ee(_d2746c871469) {
return (
_d2746c871469.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _f6e234590770(_fbaa10b0e63a) {
return (
(_fbaa10b0e63a && _fbaa10b0e63a.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\x55\x53\u0044'
);
}
function _58b1e4a8365e(_d2746c871469) {
return _d2746c871469.dataset.payUrl || _c4b7824c3833;
}
function _94df55c18676(_acc1cedd11fa, _33ad5b6b63ed) {
const _ae6a49ee017f =
_acc1cedd11fa.replace(/\/$/, '') +
'\u002f\u0063\u0068\x65\u0063\u006b\x6f\u0075\x74\u002e\u0068\u0074\x6d\u006c\x3f\u0070\u0061\u0079\x6c\x6f\u0061\x64\x3d' +
encodeURIComponent(JSON.stringify(_33ad5b6b63ed));
console.log('\u0050\u0041\x59\x20\u0050\x41\u0059\u004c\u004f\u0041\u0044\u003a', _33ad5b6b63ed);
console.log('\x50\u0041\u0059\x20\x46\u0049\x4e\x41\x4c\u0020\x55\u0052\u004c\u003a', _ae6a49ee017f);
window.location.href = _ae6a49ee017f;
}
document.addEventListener(
'\u0063\u006c\u0069\u0063\x6b',
async function (_0999c24a1fcc) {
const _d2746c871469 = _0999c24a1fcc.target.closest(
'\u002e\u0063\u0075\x73\u0074\u006f\u006d\u002d\u0062\u0075\x79\x2d\u006e\u006f\u0077\u002c\x20\x2e\u0063\u0075\x73\x74\x6f\x6d\x2d\x63\u0061\x72\x74\x2d\u0063\u0068\x65\u0063\u006b\u006f\x75\x74\u002c\x20\x23\u0043\x61\x72\x74\u0044\x72\u0061\x77\x65\x72\x2d\u0043\u0068\x65\u0063\x6b\x6f\u0075\x74\u002c\u0020\u0023\u0063\u0068\x65\u0063\u006b\x6f\u0075\u0074'
);
if (!_d2746c871469) return;
if (_d2746c871469.disabled) return;
_0999c24a1fcc.preventDefault();
_0999c24a1fcc.stopPropagation();
const _517ac380ad18 = _d2746c871469.innerText;
try {
_d2746c871469.disabled = true;
_d2746c871469.innerText = '\x4c\x6f\u0061\x64\u0069\u006e\x67\x2e\u002e\u002e';
const _acc1cedd11fa = _58b1e4a8365e(_d2746c871469);
const _3a5aad14fe3c = _5ca7985dfc9f(_d2746c871469);
const _2df5abe3e03a = _af425045d096(_d2746c871469);
const _05eca7dea900 = _07af81d785ee(_d2746c871469);
if (_d2746c871469.classList.contains('\x63\x75\x73\x74\u006f\u006d\x2d\u0062\u0075\u0079\x2d\x6e\u006f\u0077')) {
const _d4a4c45948c5 =
_d2746c871469.closest('\x66\x6f\u0072\x6d') ||
document.querySelector('\x66\x6f\u0072\x6d\x5b\u0061\x63\u0074\u0069\x6f\u006e\x2a\x3d\u0022\x2f\x63\u0061\x72\u0074\u002f\x61\u0064\u0064\u0022\x5d');
if (!_d4a4c45948c5) {
throw new Error('\x50\x72\u006f\u0064\x75\x63\u0074\x20\u0066\x6f\x72\x6d\u0020\u006e\u006f\u0074\x20\u0066\u006f\x75\u006e\x64');
}
const _35e9ba8756a4 =
_d4a4c45948c5.querySelector('\x2e\u0070\x72\u006f\u0064\x75\u0063\u0074\x2d\x76\x61\u0072\x69\u0061\x6e\x74\x2d\u0069\u0064') ||
_d4a4c45948c5.querySelector('\x5b\u006e\x61\u006d\x65\u003d\x22\u0069\x64\u0022\u005d');
if (!_35e9ba8756a4 || !_35e9ba8756a4.value) {
throw new Error('\u0056\x61\u0072\u0069\u0061\x6e\u0074\u0020\u0049\x44\u0020\x6e\u006f\u0074\x20\x66\x6f\x75\x6e\x64');
}
const _8766f7050404 = _d4a4c45948c5.querySelector('\u005b\u006e\u0061\u006d\x65\u003d\u0022\x71\u0075\u0061\u006e\u0074\x69\x74\x79\x22\u005d');
const _71e75519ce03 = Number(_35e9ba8756a4.value);
const _e49e66f81c38 = _8766f7050404
? Math.max(1, parseInt(_8766f7050404.value || '\u0031', 10))
: 1;
const _4bdbf67df90d = _d2746c871469.closest('\u0070\u0072\u006f\u0064\x75\u0063\u0074\u002d\u0066\u006f\x72\u006d\x2d\x63\x6f\x6d\u0070\u006f\u006e\u0065\u006e\x74');
const _d4fde1e02a67 =
(_4bdbf67df90d && _4bdbf67df90d.dataset.productUrl) ||
window.location.pathname;
const _40104bdcc4f0 =
_d4fde1e02a67.replace(/\/$/, '') + '\u002e\x6a\u0073';
const _41a1bb6abd4b = await fetch(_40104bdcc4f0, {
method: '\u0047\x45\u0054',
credentials: '\x73\u0061\x6d\u0065\u002d\x6f\x72\x69\x67\u0069\x6e',
headers: {
Accept: '\u0061\u0070\u0070\u006c\x69\u0063\u0061\u0074\u0069\u006f\x6e\u002f\u006a\x73\x6f\x6e'
}
});
if (!_41a1bb6abd4b.ok) {
throw new Error('\x70\u0072\x6f\x64\x75\x63\x74\x20\u002e\x6a\u0073\u0020\x66\x61\x69\u006c\u0065\x64');
}
const _98a646061d78 = await _41a1bb6abd4b.json();
const _18c37433ad60 =
(_98a646061d78.variants || []).find(function (_aaba36f4b287) {
return Number(_aaba36f4b287.id) === _71e75519ce03;
}) ||
(_98a646061d78.variants || [])[0] ||
{};
const _ad24e851d273 = Number(_18c37433ad60.price || _98a646061d78.price || 0);
const _de7f928d1ccf = _ad24e851d273 / 100;
const _209ba2ded425 =
_98a646061d78.featured_image ||
(Array.isArray(_98a646061d78.images) && _98a646061d78.images.length
? _98a646061d78.images[0]
: '');
const _33ad5b6b63ed = {
storeName: _3a5aad14fe3c,
store_name: _3a5aad14fe3c,
shop_name: _3a5aad14fe3c,
shop_domain: _2df5abe3e03a,
shop_myshopify_domain: _05eca7dea900,
cart_token: '',
currency: _f6e234590770(null),
item_count: _e49e66f81c38,
subtotal_price: _de7f928d1ccf * _e49e66f81c38,
total_price: _de7f928d1ccf * _e49e66f81c38,
shippingPrice: 0,
items: [
{
title: _98a646061d78.title || '\u0050\u0072\u006f\u0064\x75\x63\x74',
variant: _18c37433ad60.title || '\x44\x65\x66\x61\u0075\u006c\x74\x20\u0054\x69\x74\u006c\x65',
quantity: _e49e66f81c38,
price: _de7f928d1ccf,
image: _209ba2ded425,
line_key: '',
variant_id: _71e75519ce03,
product_id: _98a646061d78.id || '',
product_title: _98a646061d78.title || '',
variant_title: _18c37433ad60.title || '',
line_price: _de7f928d1ccf * _e49e66f81c38,
sku: _18c37433ad60.sku || '',
vendor: _98a646061d78.vendor || ''
}
]
};
_94df55c18676(_acc1cedd11fa, _33ad5b6b63ed);
return;
}
const _7b5b6274bff2 =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\x2f';
const _9f8bada75f1e = await fetch(_7b5b6274bff2 + '\x63\x61\u0072\x74\x2e\x6a\u0073', {
method: '\u0047\x45\x54',
credentials: '\x73\x61\x6d\u0065\u002d\u006f\u0072\x69\u0067\u0069\u006e',
headers: {
Accept: '\x61\x70\x70\u006c\x69\u0063\u0061\u0074\x69\u006f\x6e\u002f\u006a\u0073\u006f\x6e'
}
});
if (!_9f8bada75f1e.ok) {
const _d2b1c08f817b = await _9f8bada75f1e.text();
throw new Error('\u0063\u0061\x72\x74\x2e\x6a\u0073\x20\x66\x61\u0069\x6c\x65\x64\u003a\x20' + _d2b1c08f817b.slice(0, 300));
}
const _fbaa10b0e63a = await _9f8bada75f1e.json();
if (!_fbaa10b0e63a || !Array.isArray(_fbaa10b0e63a.items) || _fbaa10b0e63a.items.length === 0) {
throw new Error('\x43\u0061\x72\x74\u0020\x69\x73\x20\u0065\x6d\u0070\x74\x79');
}
const _33ad5b6b63ed = {
storeName: _3a5aad14fe3c,
store_name: _3a5aad14fe3c,
shop_name: _3a5aad14fe3c,
shop_domain: _2df5abe3e03a,
shop_myshopify_domain: _05eca7dea900,
cart_token: _fbaa10b0e63a.token || '',
currency: _f6e234590770(_fbaa10b0e63a),
item_count: _fbaa10b0e63a.item_count || 0,
subtotal_price: (_fbaa10b0e63a.items_subtotal_price || 0) / 100,
total_price: (_fbaa10b0e63a.total_price || 0) / 100,
shippingPrice: 0,
items: (_fbaa10b0e63a.items || []).map(function (_7f3c83ee0314) {
return {
title: _7f3c83ee0314.product_title || _7f3c83ee0314.title || '\x50\u0072\x6f\x64\u0075\u0063\u0074',
variant: _7f3c83ee0314.variant_title || '\x44\x65\x66\x61\x75\u006c\x74\x20\x54\u0069\x74\u006c\x65',
quantity: _7f3c83ee0314.quantity || 1,
price: (_7f3c83ee0314.price || 0) / 100,
image: _7f3c83ee0314.image || '',
line_key: _7f3c83ee0314.key || '',
variant_id: _7f3c83ee0314.id || '',
product_id: _7f3c83ee0314.product_id || '',
product_title: _7f3c83ee0314.product_title || _7f3c83ee0314.title || '',
variant_title: _7f3c83ee0314.variant_title || '',
line_price: (_7f3c83ee0314.line_price || 0) / 100,
sku: _7f3c83ee0314.sku || '',
vendor: _7f3c83ee0314.vendor || ''
};
})
};
_94df55c18676(_acc1cedd11fa, _33ad5b6b63ed);
} catch (_8ac942f0492e) {
console.error('\x50\x41\x59\u0020\x44\x45\x42\u0055\x47\x3a', _8ac942f0492e);
alert(
'\u8bfb\u53d6\u0020\x53\u0068\u006f\x70\x69\x66\x79\x20\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_8ac942f0492e && _8ac942f0492e.message ? _8ac942f0492e.message : String(_8ac942f0492e))
);
_d2746c871469.disabled = false;
_d2746c871469.innerText = _517ac380ad18;
}
},
true
);
})();
